export default "__VITE_ASSET__BajeW1p4__"